import { Component, OnInit, ViewChild, inject } from '@angular/core';
import { ClientChore } from 'app/core/models/client-chore.model';
import { ClientChoreFilters } from 'app/core/models/user-settings/client-chore-settings.model';
import { ClientChoresService, PagedClientChores } from 'app/core/services/client-chores.service';
import { LimitOffsetPaging } from 'app/core/models/paged-results/limit-offset-paging.model';
import { ClientChoreStatus } from 'app/core/enums/client-chore-status.enum';
import { ClientChoreName } from 'app/core/enums/client-chore-name.enum';
import { FormsModule } from '@angular/forms';
import { ClientChoreFiltersComponent } from '../../components/client-chore-filters/client-chore-filters.component';
import { RouterLink } from '@angular/router';

import { PaginationHeaderComponent } from '../../../shared/components/pagination-header/pagination-header.component';
import { ClientChoreListComponent } from '../../components/client-chore-list/client-chore-list.component';
import { PaginationComponent } from '../../../shared/components/pagination/pagination.component';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@Component({
    templateUrl: './capture-admin-client-ehr-file-reviews.component.html',
    styleUrls: ['./capture-admin-client-ehr-file-reviews.component.scss'],
    imports: [FormsModule,
              ClientChoreFiltersComponent,
              RouterLink,
              PaginationHeaderComponent,
              ClientChoreListComponent,
              PaginationComponent,
              MatProgressSpinner]
})
export class CaptureAdminClientEhrFileReviewsComponent implements OnInit {
  private clientChoresService = inject(ClientChoresService);

  clientChores: ClientChore[] = [];
  filterableStatuses = Object.values(ClientChoreStatus);
  filters: ClientChoreFilters = this.newFilters();
  paging: LimitOffsetPaging = LimitOffsetPaging.empty;
  loading = true;

  @ViewChild(ClientChoreFiltersComponent) choreFilters: ClientChoreFiltersComponent;

  ngOnInit() {
    this.getClientChores();
  }

  onPageSizeChange(size: number) {
    this.paging.pageSize = size;
    this.getClientChores();
  }

  onPageChange(_page: number) {
    this.getClientChores();
  }

  onFilterChange() {
    this.getClientChores();
  }

  onClearClick() {
    this.filters = this.newFilters();
    this.choreFilters?.resetSubmittedByFilter();
    this.paging.currentPage = 1;
    this.getClientChores();
  }

  getClientChores() {
    this.loading = true;
    this.clientChoresService
      .getList(
        this.paging.currentPage,
        this.paging.pageSize,
        this.filters.selectedStatuses,
        this.filters.selectedClientIds,
        this.filters.selectedUserIds,
        this.filters.selectedNames,
        this.filters.inactive,
        this.filters.requiresReview,
      )
      .subscribe((result: PagedClientChores) => {
        this.clientChores = result.clientChores;
        this.paging = result.meta.paging;
        this.loading = false;
      });
  }

  private newFilters(): ClientChoreFilters {
    const filters = new ClientChoreFilters();
    filters.selectedNames = [ClientChoreName.clientFileQualityCheck];
    return filters;
  }
}
